import _isNil from 'lodash/isNil';

const NON_BREAKING_SPACE = ' ';

export const getStringifiedValue = (value) => (!_isNil(value) ? `${value}` : NON_BREAKING_SPACE);
